import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

export const StyledCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  // TODO: no VDS token for #F5F5F5 — needs designer input (Barry Richardson)
  backgroundColor: '#F5F5F5',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: borderRadius.md,
  overflow: 'hidden',
  padding: '16px',
}));

export const StyledReorderSection = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyledSerialNumberText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
}));

export const StyledReorderButtons = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const StyledReorderButton = styled(IconButton)(({ theme, disabled }) => ({
  height: '24px',
  width: '24px',
  color: `${disabled ? theme.palette.divider : theme.palette.text.secondary} !important`,
}));

export const StyledDragHandle = styled(IconButton)(({ theme }) => ({
  height: '24px',
  width: '24px',
  color: theme.palette.text.secondary,
  cursor: 'grab',
  // Required by dnd-kit's PointerSensor so touch drags aren't hijacked by
  // the browser's default scroll/pan gesture on the handle.
  touchAction: 'none',
  '&:active': {
    cursor: 'grabbing',
  },
}));

export const StyledInfoSection = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '8px',
}));

export const StyledStatusChipsContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  alignItems: 'center',
}));

export const StyledTitleSection = styled(Box)(() => ({
  marginTop: '24px',
}));

export const StyledDetailsSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '12px',
  flexGrow: 1,
}));

export const StyledDetailRow = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
}));

export const StyledFooterActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  borderTop: `1px solid ${theme.palette.divider}`,
  marginTop: '12px',
  paddingTop: '12px',
}));
